import useFindCustomersQuery from '@/api/queries/useFindRetailersQuery';
import Button from '@/components/Button';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import { CustomerEditPath, CustomerStoreListPath } from '@/modules/supplier/paths';
import { Link } from 'react-router-dom';

const CustomerTable = ({ searchQuery, page = 1, onChangePage = () => {} }: SearchProps) => {
  const {
    retailers: customers,
    isLoading,
    error,
    itemsPerPage,
  } = useFindCustomersQuery(page, searchQuery);

  if (!isLoading && !error && customers.items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-8">
        <p>No customers found.</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Customer Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.items.map((customer, index) => {
              if (customer.id === undefined) {
                return;
              }
              return (
                <tr key={index}>
                  <td>
                    <Link
                      to={CustomerEditPath.withId(customer.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {customer.name}
                    </Link>
                  </td>
                  <td>{customer.customerCode}</td>
                  <td>
                    <Button
                      to={CustomerStoreListPath.withCustomerId(customer.id)}
                      variant="secondary"
                      size="xs"
                    >
                      View Stores
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading ? (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={customers.totalCount || 0}
          estimatedTotalCount={customers.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default CustomerTable;
